import classNames from 'classnames';
import React from 'react';

import {
	ProductIcon,
	ProductIconType,
} from 'cond-ui-kit';



export enum HealthIconImpact {
	Negative = 'negative',
	Neutral = 'neutral',
	Positive = 'positive',
}

const IMPACT_COLOR: Record<HealthIconImpact, string> = {
	[HealthIconImpact.Positive]: '#008d61', // Semantic/Accent/greenTea/700
	[HealthIconImpact.Negative]: '#c12020', // Semantic/Danger/500
	[HealthIconImpact.Neutral]: '#b6bbbf', // Semantic/Neutral/200
};

type Props = {
	/** Active highlight animation */
	highlighted?: boolean,
	/** Possibility to extend health icon by impact visualisation */
	impact?: HealthIconImpact,
	size?: number,
};

const HealthIcon: React.FC<Props> = (props) => {
	const {
		highlighted = false,
		impact,
		size = 15,
	} = props;

	return (
		<div
			className={classNames({
				'health-icon-animation': true,
				'health-icon-animation--animation-enabled': highlighted,
			})}
			style={{
				height: size,
				width: size,
			}}
		>
			<div className="health-icon-animation__icon">
				<ProductIcon
					color={IMPACT_COLOR[impact ?? HealthIconImpact.Neutral]}
					size={size}
					type={ProductIconType.HeartbeatOutline}
				/>
			</div>
		</div>
	);
};



export default HealthIcon;
